import React from "react";
import "./Objectives.css";

const Objectives = () => {
  const objectives = [
    "Spreading awareness of information technology in the field of e-learning.",
    "Raising awareness of traditional and emerging technologies, including the Internet of Things.",
    "Supporting research and studies in e-learning.",
    "Disseminating knowledge and exchanging experiences in leadership and digital transformation.",
    "Promoting digital culture within various segments of society.",
    "Participating in preparing technical cadres.",
    "Raising societal awareness of technology applications.",
    "Organizing specialized studies in technical education.",
    "Evaluating software-related policies.",
    "Enhancing the efficiency of employing IoT.",
    "Increasing cultural awareness in cloud computing.",
    "Promoting awareness of digital gaming culture.",
    "Supporting research in cloud computing.",
    "Providing consulting and supervisory services in computer technology.",
    "Offering solutions and services in digital transformation.",
    "Developing digital technology software and applications.",
  ];

  return (
    <div className="objectives-page">
      <header className="objectives-hero">
        <div className="objectives-hero-inner">
          <div className="objectives-hero-text">
            <h1 className="objectives-title">Our Objectives</h1>
            <p className="objectives-subtitle">
              Clear, measurable directions that guide OGITS programs, partnerships, and impact.
            </p>
          </div>

          <div className="objectives-kpi" aria-label="Objectives summary">
            <div className="kpi-card">
              <div className="kpi-number">{objectives.length}</div>
              <div className="kpi-label">Objectives</div>
            </div>
          </div>
        </div>
      </header>

      <main className="objectives-main">
        <div className="objectives-grid" role="list">
          {objectives.map((text, idx) => (
            <article
              key={idx}
              className="objective-card"
              role="listitem"
              tabIndex={0}
              aria-label={`Objective ${idx + 1}`}
            >
              <div className="objective-badge">
                {String(idx + 1).padStart(2, "0")}
              </div>
              <p className="objective-text">{text}</p>
            </article>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Objectives;
